<div>
  <h3 style="text-align: center;">Items Marked Must Correct</h3>
  <div mat-dialog-content  fxLayout.xs="column" style="width:95%; text-align:center" >

    <div *ngIf="data.rf_air_is_filtered == 'Must Correct'">
      <p>9.3 All return air and mechanically supplied outdoor air passes through filter prior to conditioningt</p>
    </div>
    <div *ngIf="data.rf_attic_dropdown == 'Must Correct'">
      <p>4.10 Attic access panels, drop-down stairs, & whole-house fans equipped with durable ≥ R-10 cover that is gasketed (i.e., not caulked). Fan covers either installed on house side or mechanically operated.</p>
    </div>
    <div *ngIf="data.rf_attic_knee_walls == 'Must Correct'">
      <p>2.3 Attic knee walls and skylight shaft walls</p>
    </div>
    <div *ngIf="data.rf_bathroom_cfm == 'Must Correct'">
      <p>8.2 Bathroom CFM</p>
    </div>
    <div *ngIf="data.rf_boots_sealed == 'Must Correct'">
      <p>6.4.1 Rough-in: The greater of ≤ 4 CFM25 per 100 sq. ft. of CFA or ≤ 40 CFM, with air handler & all ducts, building cavities used as ducts, & duct boots installed. In addition, all duct boots sealed to finished surface, Rater-verified at final.</p>
    </div>
    <div *ngIf="data.rf_cantilevered_floor == 'Must Correct'">
      <p>2.7 All other floors adjoining unconditioned space (e.g., rim / band joists at exterior wall or at porch roof)</p>
    </div>
    <div *ngIf="data.rf_co_less_35ppm == 'Must Correct'">
      <p>10.3 If unvented combustion appliances other than cooking ranges or ovens are located inside the home’s pressure boundary, the Rater has followed Section 805 of RESNET’s Standards, encompassing ANSI/ACCA 12 QH-2014, Appendix A, Section A3 (Carbon Monoxide Test), and verified the equipment meets the limits defined within</p>
    </div>
    <div *ngIf="data.rf_continuous_control == 'Must Correct'">
      <p>7.2 A readily-accessible ventilation override control installed and also labeled if its function is not obvious (e.g., a label-is required for a standalone wall switch, but not for a switch that’s on the ventilation equipment)</p>
    </div>
    <div *ngIf="data.rf_continuous_fan_esq == 'Must Correct'">
      <p>7.5 If system utilizes the HVAC fan, then the specified fan type is ECM / ICM (4.7), or the controls will reduce the standalone ventilation run-time by accounting for hours when the HVAC system is heating or cooling</p>
    </div>
    <div *ngIf="data.rf_door_to_uncon == 'Must Correct'">
      <p>4.9 Doors adjacent to unconditioned space (e.g., attics, garages, basements) or ambient conditions made substantially air-tight with weatherstripping or equivalent gasket</p>
    </div>
    <div *ngIf="data.rf_double_walls == 'Must Correct'">
      <p>2.5 Double-walls and all other exterior walls</p>
    </div>
    <div *ngIf="data.rf_dropped_ceiling_soffit == 'Must Correct'">
      <p>2.1 Dropped ceilings / soffits below unconditioned attics, and all other ceilings</p>
    </div>
    <div *ngIf="data.rf_duct_flue_shaft == 'Must Correct'">
      <p>4.1 Ducts, flues, shafts, plumbing, piping, wiring, exhaust fans, & other penetrations to unconditioned space sealed, with blocking / flashing as needed</p>
    </div>
    <div *ngIf="data.rf_fenlevels == 'Must Correct'">
      <p>1.1 Fenestration meets or exceeds levels specified in Item 2.1 of the Rater Design Review Checklist</p>
    </div>
    <div *ngIf="data.rf_finalcfm == 'Must Correct'">
      <p> 6.4.2 Final: The greater of ≤ 8 CFM25 per 100 sq. ft. of CFA or ≤ 80 CFM, with the air handler & all ducts, building cavities used as ducts, duct boots, & register grilles atop the finished surface (e.g., drywall, floor) installed</p>
    </div>
    <div *ngIf="data.rf_flr_o_unconbsmt_crawl == 'Must Correct'">
      <p> 2.6 Floors above garages, floors above unconditioned basements or crawlspaces, and cantilevered floors</p>
    </div>
    <div *ngIf="data.rf_gasketed_filter == 'Must Correct'">
      <p>9.2 Filter access panel includes gasket or comparable sealing mechanism and fits snugly against the exposed edge of filter when closed to prevent bypass</p>
    </div>
    <div *ngIf="data.rf_inlet_2ft == 'Must Correct'">
      <p>7.7.2 Inlet is ≥ 2 ft. above grade or roof deck; ≥ 10 ft. of stretched-string distance from known contamination sources- (e.g., stack, vent, exhaust, vehicles) not exiting the roof, and ≥ 3 ft. distance from sources exiting the roof</p>
    </div>
    <div *ngIf="data.rf_inlet_outside == 'Must Correct'">
      <p>7.7.1 Inlet pulls ventilation air directly from outdoors and not from attic, crawlspace, garage, or adjacent dwelling unit</p>
    </div>
    <div *ngIf="data.rf_inlet_screen == 'Must Correct'">
      <p>7.7.3 Inlet is provided with rodent / insect screen with ≤ 0.5 inch mesh</p>
    </div>
    <div *ngIf="data.rf_ins_headr == 'Must Correct'">
      <p>3.4.3b Headers above windows & doors insulated ≥ R-3 for 2x4 framing or equivalent cavity width, and ≥ R-5 for all other assemblies (e.g., with 2x6 framing) , AND;</p>
    </div>
    <div *ngIf="data.rf_ins_sheathing == 'Must Correct'">
      <p>3.4.1 Continuous rigid insulation, insulated siding, or combination of the two is:≥ R-3 in CZ 1-4; ≥ R-5 in CZ 5-8, OR</p>
    </div>
    <div *ngIf="data.rf_ins_wall_intersect == 'Must Correct'">
      <p>3.4.3d Interior / exterior wall intersections insulated to same R-value as rest of exterior wall,</p>
    </div>
    <div *ngIf="data.rf_insachieve == 'Must Correct'">
      <p>1.3 All insulation achieves RESNET-defined Grade I installation. See Footnote 4 for alternatives.</p>
    </div>
    <div *ngIf="data.rf_insmeets == 'Must Correct'">
      <p>1.2 Insulation meets or exceeds levels specified in Item 3.1 of the Rater Design Review Checklist</p>
    </div>
    <div *ngIf="data.rf_kinked_ducts == 'Must Correct'">
      <p>6.1 Ductwork installed without kinks, sharp bends, compressions, or excessive coiled flexible ductwork</p>
    </div>
    <div *ngIf="data.rf_kitchen_cfm == 'Must Correct'">
      <p>8.1 Kitchen CFM</p>
    </div>
    <div *ngIf="data.rf_leakageotdr == 'Must Correct'">
      <p>6.5 Rater-measured duct leakage to outdoors the greater of ≤ 4 CFM25 per 100 sq. ft. of CFA or ≤ 40 CFM25</p>
    </div>
    <div *ngIf="data.rf_measvent == 'Must Correct'">
      <p>7.1 Rater-measured ventilation rate is within either ± 15 CFM or ±15% of design value (2.3)</p>
    </div>
    <div *ngIf="data.rf_merv6_filters == 'Must Correct'">
      <p>9.1 At least one MERV 6 or higher filter installed in each ducted mechanical system in a location that facilitates access and regular service by the owner</p>
    </div>
    <div *ngIf="data.rf_min_r6_uncond == 'Must Correct'">
      <p>6.3 All supply and return ducts in unconditioned space, including connections to trunk ducts, are insulated to ≥ R-6</p>
    </div>
    <div *ngIf="data.rf_min_stud_spacing == 'Must Correct'">
      <p>3.4.3e Minimum stud spacing of 16 in. o.c. for 2x4 framing in all Climate Zones and, in CZ 6-8, 24 in. o.c. for 2x6 framing</p>
    </div>
    <div *ngIf="data.rf_min_wind_dr_framing == 'Must Correct'">
      <p>3.4.3c Framing limited at all windows & doors to one pair of king studs, plus one pair of jack studs per window opening to support the header and sill,</p>
    </div>
    <div *ngIf="data.rf_modelnumbers == 'Must Correct'">
      <p>5.1 HVAC manufacturer & model number on installed equipment matches...</p>
    </div>
    <div *ngIf="data.rf_pressure_balanced == 'Must Correct'">
      <p>6.2 Bedrooms pressure-balanced using any combination of transfer grills, jump ducts, dedicated return ducts, and/or undercut doors to achieve a Rater-measured pressure differential ≤ 3 Pa with respect to the main body of the house when all bedroom doors are closed and all air handlers are operating. See Footnote 34 for alternative.</p>
    </div>
    <div *ngIf="data.rf_quiet_continuous_fans == 'Must Correct'">
      <p>7.5 If system utilizes the HVAC fan, then the specified fan type is ECM / ICM (4.7), or the controls will reduce the standalone ventilation run-time by accounting for hours when the HVAC system is heating or cooling</p>
    </div>
    <div *ngIf="data.rf_quitet_intermittent_fans == 'Must Correct'">
      <p>7.4 System fan rated ≤ 3 sones if intermittent and ≤ 1 sone if continuous, or exempted</p>
    </div>
    <div *ngIf="data.rf_r6_corner == 'Must Correct'">
      <p>3.4.3a Corners insulated ≥ R-6 to edge </p>
    </div>
    <div *ngIf="data.rf_r21_attic_platform == 'Must Correct'">
      <p>3.3 Insulation beneath attic platforms (e.g., HVAC platforms, walkways) ≥ R-21 in CZ 1-5; ≥ R-30 in CZ 6-8</p>
    </div>
    <div *ngIf="data.rf_r21_o_wall == 'Must Correct'">
      <p>3.1 For insulated ceilings with attic space above (i.e., non-cathedralized), Grade I insulation extends to the inside face of the exterior wall below and is ≥ R-21 in CZ 1-5; ≥ R-30 in CZ 6-8</p>
    </div>
    <div *ngIf="data.rf_recessed_light == 'Must Correct'">
      <p>4.2 Recessed lighting fixtures adjacent to unconditioned space ICAT labeled and gasketed. Also, if in insulated ceiling without attic above, exterior surface of fixture insulated to ≥ R-10 in CZ 4-8.</p>
    </div>
    <div *ngIf="data.rf_returnside == 'Must Correct'">
      <p>7.3 No outdoor air intakes connected to return side of the HVAC system, unless controls are installed to operate intermittently & automatically based on a timer and to restrict intake when not in use (e.g., motorized damper)</p>
    </div>
    <div *ngIf="data.rf_sealed_common_wall == 'Must Correct'">
      <p>4.8 In multifamily buildings, the gap between the common wall (e.g. the drywall shaft wall) and the structural framing between units sealed at all exterior boundaries</p>
    </div>
    <div *ngIf="data.rf_sealedmarriagejointsmodhomes == 'Must Correct'">
      <p>4.7 Walls that separate attached garages from occupiable space sealed and, also, an air barrier installed and sealed at floor cavities aligned with these walls</p>
    </div>
    <div *ngIf="data.rf_sealedsillplate == 'Must Correct'">
      <p>4.3 Above-grade sill plates adjacent to conditioned space sealed to foundation or sub-floor. Gasket also placed beneath above-grade sill plate if resting atop concrete / masonry & adjacent to cond. space</p>
    </div>
    <div *ngIf="data.rf_sealedtopplate == 'Must Correct'">
      <p>4.5 Drywall sealed to top plate at all unconditioned attic / wall interfaces using caulk, foam, drywall adhesive (but not other construction adhesives), or equivalent material. Either apply sealant directly between drywall and top plate or to the seam between the two from the attic above.</p>
    </div>
    <div *ngIf="data.rf_sealedwindows == 'Must Correct'">
      <p>4.6 Rough opening around windows & exterior doors sealed</p>
    </div>
    <div *ngIf="data.rf_sip == 'Must Correct'">
      <p>3.4.2 Structural Insulated Panels OR; Insulated Concrete Forms OR; Double-wall framing;</p>
    </div>
    <div *ngIf="data.rf_slab_edge_insulation == 'Must Correct'">
      <p>3.2 For slabs on grade in CZ 4-8, 100% of slab edge insulated to ≥ R-5 at the depth specified by the 2009 IECC and aligned with the thermal boundary of the walls'</p>
    </div>
    <div *ngIf="data.rf_topplatespresent == 'Must Correct'">
      <p>4.4 Continuous top plate or blocking is at top of walls adjoining unconditioned space, and sealed</p>
    </div>
    <div *ngIf="data.rf_vent_combust_right == 'Must Correct'">
      <p>10.1 Furnaces, boilers, and water heaters located within the home’s pressure boundary are mechanically drafted or direct-vented. See Footnote 56 for alternatives.</p>
    </div>
    <div *ngIf="data.rf_vent_fireplace_right == 'Must Correct'">
      <p>10.2 Fireplaces located within the home’s pressure boundary are mechanically drafted or direct-vented.</p>
    </div>
    <div *ngIf="data.rf_wall_a_porch_roof == 'Must Correct'">
      <p>2.4 Walls adjoining porch roofs or garages</p>
    </div>
    <div *ngIf="data.rf_wall_b_shower_tub == 'Must Correct'">
      <p>2.2 Walls behind showers, tubs, staircases, and fireplaces</p>
    </div>






  </div>



</div>
